export default __webpack_public_path__ + "static/media/HostaAI_Logo.07296f31.png";